var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75112 17.6929C2.79602 16.7704 2.0342 15.667 1.51011 14.4469C0.98602 13.2269 0.710158 11.9147 0.69862 10.5869C0.687082 9.2591 0.940099 7.94231 1.44291 6.71334C1.94572 5.48438 2.68825 4.36786 3.62717 3.42893C4.5661 2.49001 5.68262 1.74747 6.91158 1.24467C8.14055 0.741856 9.45734 0.488839 10.7851 0.500378C12.1129 0.511916 13.4251 0.787778 14.6452 1.31187C15.8652 1.83596 16.9687 2.59778 17.8911 3.55288C19.7127 5.4389 20.7206 7.96493 20.6979 10.5869C20.6751 13.2089 19.6234 15.717 17.7693 17.5711C15.9152 19.4251 13.4071 20.4768 10.7851 20.4996C8.16317 20.5224 5.63715 19.5145 3.75112 17.6929ZM12.2211 10.6229L15.0511 7.79288L13.6411 6.38288L10.8211 9.21288L7.99112 6.38288L6.58112 7.79288L9.41112 10.6229L6.58112 13.4529L7.99112 14.8629L10.8211 12.0329L13.6511 14.8629L15.0611 13.4529L12.2311 10.6229H12.2211Z",
    fill: "#BBBBF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopCrossIcon);
export default __webpack_public_path__ + "static/media/StopCrossIcon.46bc40d230f21cb81109cce1b4ec6166.svg";
export { ForwardRef as ReactComponent };